<template>
    <div class="cta-container" :data-margin="margin" :data-size="size">
        <button :type="type" v-if="!link" :data-shape="shape ? shape : 'rectangle'" :class="[{loading:loading},{active:active}]" :data-icon="icon"  v-on:click="$emit('click')" :disabled="(loading || disabled)">
            <transition name="fade" >
                <div class="loading" :class="{show:loading}" v-show="loading"></div>
            </transition>
            <span v-if="!loading">{{text}}</span>
        </button>

        <router-link v-if="link" v-on:click="$emit('click')" :class="{loading:loading}" :data-shape="shape" :data-icon="icon" :disabled="(loading || disabled)" :to="{ name: link, params:linkparams}" >{{text}}</router-link>

    </div>
</template>

<script>
    export default {

        mixins:[],
        props: [
            'loading',
            'text',
            'disabled',
            'icon',
            'link',
            'linkparams',
            'type',
            'shape',
            'margin',
            'size',
            'active'
        ],
        inject: ['$validator'],
        components: {

        },
        data : function(){       
            return {
            };
        },
        watch :{


        },
        created : function(){
            
        },
        mounted : function ()
        {
        },
        methods:{

          
        }
    }
</script>



